import { Component, OnInit } from '@angular/core';
import {DataService} from '../../services/data.service';
import {ApiService} from '../../services/api.service';
import {RSDialogService} from '../../../libs/rsnotify/rsdialog.service';
import {Router} from '@angular/router';
import {Hort360PropertySummary} from '../../../../functions/src/types';
import {PropertyService} from '../../services/property.service';

@Component({
  selector: 'app-growers',
  templateUrl: './growers.component.html',
  styleUrls: ['./growers.component.scss']
})
export class GrowersComponent implements OnInit {

  constructor(
      private dataService: DataService,
      private rsDialog: RSDialogService,
      private router: Router,
      public propertyService: PropertyService
  ) { }

  ngOnInit(): void { }

  userProfile(user: Hort360PropertySummary) {
    this.router.navigate(['growers', user.id]);
  }

}
